import * as React from "react";
const RightArrow = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={14}
    fill="none"
    {...props}
  >
    <path
      stroke="#4F2E03"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M15 7H1m14 0L9 1m6 6-6 6"
    />
  </svg>
);
export default RightArrow;
